<template>
  <div
  class="d-flex justify-content-between"
    style="
      width: 100%;
      height: 100%;
    "
  >
    <div
      class="none-width flex-grow-1 d-flex flex-column section-container"
      :class="{ dark: skinType }"
    >
      <el-tabs
        v-model="activeName"
        type="card"
        @tab-click="tabCon"
        :class="{ dark: skinType }"
      >
        <el-tab-pane label="今日用电" name="first"></el-tab-pane>
        <el-tab-pane label="昨日用电" name="second"></el-tab-pane>
        <el-tab-pane label="本月用电" name="third"></el-tab-pane>
        <el-tab-pane label="上月用电" name="fourth"></el-tab-pane>
      </el-tabs>
      <echart1
        v-if="data"
        class="none-height flex-grow-1"
        :data="data"
      ></echart1>
      <no-data-temporarily
        v-else
        class="none-height flex-grow-1"
      ></no-data-temporarily>
    </div>
    <div
      class="none-width flex-grow-1 section-container"
      :class="{ dark: skinType }"
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
      "
    >
      <div class="section-header">
        <div class="lan"></div>
        <div class="tip4text">当前负荷</div>
      </div>
      <echart3
        v-if="data3"
        style="flex-grow: 1; width: 100%"
        :data3="data3"
      ></echart3>
     <no-data-temporarily
        v-else
        style="flex-grow: 1; width: 100%"
      ></no-data-temporarily>
    </div>
  </div>
</template>
<script>
import echart1 from '@/components/realtime-monitoring/ele-situation/utils/echart1.vue';
import { ele3 } from '@/api/ele-situation/ele3and4';
import { ele5 } from '@/api/ele-situation/ele5';
import echart3 from '@/components/realtime-monitoring/ele-situation/utils/echart3.vue';
import NoDataTemporarily from '@/components/utils/no-data-temporarily.vue';
import TurnAskingMixin from '@/mixins/turn-ask';

export default {
  mixins: [TurnAskingMixin],
  data() {
    return {
      activeName: 'first',
      // 第一个图的数据
      data: null,
      // 第二个图的数据
      data3: null,
    };
  },
  props: {
    proId: String,
  },
  components: {
    echart1,
    echart3,
    NoDataTemporarily,
  },
  watch: {
    proId() {
      this.requestEle3Data(0);
      this.requestEle4Data();
    },
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    requestEle4Data() {
      ele5({
        ProjectIdStr: this.proId,
      })
        .then((res) => {
		  if(res.xAxisData.length > 8) {
			res.xAxisData.forEach(function(item,index,arr) {
				if(item.match(RegExp(/变/))){
					arr[index] = item.substring(0,item.indexOf('变')+1)
				}else {
					arr[index] = item.substr(0,3)
				}
			})
			this.data3 = res
		  }else {
			  this.data3 = res;
		  }
        })
        .catch(() => {
          this.data3 = null;
        }).then(() => {
          this.turnAsking({
            routeName: this.routeName,
            nowRouteName: this.$route.name,
            func: this.requestEle4Data,
          }, 5000);
        });
    },
    requestEle3Data(index) {
      const a = parseInt(index, 10) + 1;
      // 点击选择时间 再次请求
      ele3({
        ProjectIdStr: this.proId,
        DateType: a,
      })
        .then((res) => {
          this.data = [];
          if (res.length > 0) {
            for (let i = 0; i < res.length; i += 1) {
              const dataobj = {
                value: res[i].PowerConsumption,
                name: res[i].EquipmentName,
              };
              this.data.push(dataobj);
            }
          }
        })
        .catch(() => {
          this.data = null;
        });
    },
    tabCon(tab) {
      this.selectTab = tab;
      this.requestEle3Data(tab.index);
    },
  },
};
</script>
<style lang="less" scoped>
.el-tabs,
.el-tabs__content,
.el-tab-pane {
  flex-grow: 0 !important;
  padding: 0;
}
.eletab {
  width: 100%;
  height: 15%;
  display: flex;
  /* border-bottom: #d7d8da solid 0.1rem; */
}
.tabcontent {
  width: 100%;
  display: flex;
}
.tabt {
  width: 12%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  /* border:tomato solid 0.1rem; */
  z-index: 99;
  margin-top: -0.1rem;
  border: rgba(255, 255, 255, 0) solid 0.1rem;
  border-bottom: rgba(255, 255, 255, 0) solid 0.1rem;
}
.ele3left {
  width: 49.3%;
  height: 100%;
}
.section-header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;
  position: relative;
}
.lan {
  width: 0.3rem;
  height: 1.55rem;
  background: #2e9bf3;
  position: absolute;
  left: 1%;
}
.tip4text {
  font-size: 1.2rem;
  position: absolute;
  left: 3%;
}
.section-container+.section-container {
  margin-left:1rem;
}
</style>
